import { supabase } from '../supabaseClient';

/**
 * Chama a Edge Function agent-intake-document com JWT do Supabase Auth.
 * NUNCA usar x-api-key, apikey ou service_role_key no frontend.
 *
 * Modos:
 *  - { mode: 'extract', text, document_type, imovel_id?, empresa_id?, initiated_by, source_type }
 *    → retorna { ok, run_id, entities, actions }
 *  - { mode: 'apply', run_id, action_ids, applied_by }
 *    → aplica ações selecionadas e retorna { ok, applied, errors }
 */
export async function callIntakeAgent(payload) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Sessão expirada — faça login novamente.');

  const url = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/agent-intake-document`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(payload),
  });

  let body;
  try {
    body = await response.json();
  } catch {
    body = { ok: false, error: `HTTP ${response.status} — resposta inválida` };
  }
  if (!response.ok && body?.ok !== false) {
    body = { ok: false, error: body?.error || `HTTP ${response.status}` };
  }
  return body;
}
